import React from 'react';
import '../../CustomModule.css';
import CommonAction from './CommonAction';

export function DividerControl({
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  placeholder,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  editingInput,
  dividerProperty,
  otherConfiguration,
  dividerStyle,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const dividerStyleObj = {
    width: `${dividerProperty?.width || 100}%`,
    borderTop: `${dividerProperty?.weight || 1}px ${dividerStyle?.value || 'solid'}`,
    marginTop: `${dividerProperty?.gap || 5}px`,
    marginBottom: `${dividerProperty?.gap || 5}px`,
    borderColor: otherConfiguration?.color || 'rgba(0,0,0,1)',
  };
  const otherConfig = {
    textAlign: otherConfiguration?.alignment || 'left',
  };

  return (
    <div className="position-relative" style={otherConfig}>
      <div style={dividerStyleObj} className="position-relative d-inline-block">
        {placeholder && <label className="divider-placeholder">{placeholder}</label>}
      </div>
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  );
}
export default DividerControl;
